import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationRegionInitialState';
import { _setRegion } from './organizationRegionActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationRegionForm = createAsyncThunk(
  'stop/getOrganizationRegionForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationRegionSlice = createSlice({
  name: 'stop/organizationRegionForm',
  initialState,
  reducers: {
    setRegion: _setRegion,
    resetOrganizationRegionForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationRegionForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setRegion, resetOrganizationRegionForm } =
  organizationRegionSlice.actions;

export default organizationRegionSlice.reducer;
